import React, { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import MultiSelect from "../common/Form/Multiselect";
import { Button, Col, FormGroup, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import styles from "./MasterForm.module.scss"
import { BiRupee } from "react-icons/bi";
import { capitalizeFirstLetter, OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import { masterDataActions } from "../../actions/masterData.action";
const AddMasterData = (props) => {
    const [departmentOption, setDepartmentOption] = useState([])
    const departmentment = useSelector((state) => state.masterData.department);
    const dispatch = useDispatch()
    useEffect(() => {
        if (departmentment && departmentment.length > 0) {
            const resVal = departmentment.map((val) => {
                return {
                    id: val?.id,
                    value: val?.id,
                    label: val?.name,
                };
            });
            setDepartmentOption(resVal);
        }
    }, [departmentment]);

    const typeOption = [{
        value: "department",
        label: "Department"
    }, {
        value: "designation",
        label: "Designation"
    }, {
        value: "skills",
        label: "Skills"
    }]


    return (
        <div>
            <Formik
                initialValues={{
                    type: "",
                    parentId: "",
                    data: [{
                        name: "",
                        description: "",
                        min_salary: "",
                        max_salary: ""
                    }],

                }}
                onSubmit={values => {
                    if (values) {
                        dispatch(masterDataActions.createMasterData(values)).then((res) => {
                            if (res) {
                                if (props?.activeTab) {
                                    dispatch(masterDataActions.getDesignationBydepartment(values?.parentId))
                                    dispatch(masterDataActions.getDepartments())
                                } else {
                                    dispatch(masterDataActions.getSkills())
                                }
                                props?.addMasterDataToggle()
                                if (values?.type === "skills") {
                                    props?.setActiveTab(false)
                                } else {
                                    props?.setActiveTab(true)
                                }

                            }
                        })
                    }
                }}
                validationSchema={Yup.object().shape({
                    type: Yup.string().required("Type is required")
                })}
                render={({ values, touched,
                    errors, }) => (
                    <Form>

                        <div className={styles.MasterForm}>
                            <FormGroup className="form-group">
                                {/* <Label className={styles.formLabel}>Select Type</Label> */}
                                <Field
                                    name="type"
                                    id="type"
                                    placeholder="Select Type"
                                    isMulti={false}
                                    component={MultiSelect}
                                    options={typeOption}
                                    autocomplete="off"
                                />
                                {errors.type || touched.type ? (
                                    <div className={styles.formError}>{errors.type}</div>
                                ) : null}
                            </FormGroup>
                            {values?.type === "designation" ?
                                <FormGroup className="form-group">
                                    <Label className={styles.formLabel}>Department</Label>
                                    <Field
                                        name="parentId"
                                        id="parentId"
                                        placeholder="Select Department"
                                        isMulti={false}
                                        component={MultiSelect}
                                        options={departmentOption}
                                        autocomplete="off"
                                        maxlength="20"
                                    />

                                </FormGroup> : ""
                            }
                            <FieldArray
                                name="data"
                                render={arrayHelpers => (
                                    values.type && values.data && values.data.length > 0 ? (
                                        values.data.map((val, index) => (
                                            <div>
                                                <FormGroup className="form-group">
                                                    <label htmlFor="name" className="form-label required-label">
                                                        Add {capitalizeFirstLetter(values.type)}
                                                    </label>
                                                    <div className="form-flex">
                                                        <Field
                                                            type="text"
                                                            className="form-control"
                                                            name={`data.${index}.name`}
                                                            maxlength="20"
                                                            pattern="^[^,]*$"
                                                            title="Comma is not allowed."
                                                            required
                                                        />
                                                        {values.data.length !== index + 1 ? (
                                                            <div
                                                                className="button remove remove-button-part"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                <span>x</span>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className={`button add add-button-part`}
                                                                type="button"
                                                                onClick={() => arrayHelpers.insert(index + 1, {
                                                                    name: "",
                                                                    description: "",
                                                                    min_salary: "",
                                                                    max_salary: ""
                                                                })}
                                                            >
                                                                <span>+</span>
                                                            </button>
                                                        )}
                                                    </div>
                                                </FormGroup>
                                                {
                                                    values.type === "designation" ?
                                                        <><FormGroup className="form-group">
                                                            <Label className={styles.formLabel}>CTC</Label>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <InputGroup>
                                                                        <InputGroupText>
                                                                            <BiRupee />{" "}
                                                                        </InputGroupText>
                                                                        <Field
                                                                            className="form-control"
                                                                            onKeyPress={(event) => {
                                                                                OnlyNumberLength(event);
                                                                            }}
                                                                            maxlength="8"
                                                                            placeholder="Min."
                                                                            name={`data.${index}.min_salary`}
                                                                            autocomplete="off" />
                                                                    </InputGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <InputGroup>
                                                                        <InputGroupText>
                                                                            <BiRupee />{" "}
                                                                        </InputGroupText>
                                                                        <Field
                                                                            className="form-control"
                                                                            onKeyPress={(event) => {
                                                                                OnlyNumberLength(event);
                                                                            }}
                                                                            maxlength="8"
                                                                            placeholder="Max."
                                                                            name={`data.${index}.max_salary`}
                                                                            autocomplete="off" />
                                                                    </InputGroup>
                                                                </Col>
                                                            </Row>
                                                        </FormGroup>
                                                            <FormGroup className="form-group">
                                                                <Label className={styles.formLabel}>Description</Label>
                                                                <Field
                                                                    as="textarea"
                                                                    className="form-control"
                                                                    name={`data.${index}.description`}
                                                                    autocomplete="off"
                                                                    maxlength="200"
                                                                />
                                                            </FormGroup></>
                                                        : ""
                                                }
                                            </div>

                                        ))
                                    ) : ""

                                )} />



                            <Button
                                type="submit"
                                className={styles.brandButton}
                                disabled={values.type === "" ? true : false}
                            >
                                Save
                            </Button>

                        </div>
                    </Form>
                )}
            />
        </div>
    )
};

export default AddMasterData;
